import { NavLink, useLocation } from 'react-router-dom';
import List from '@mui/material/List';

import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import Link from '@mui/material/Link';
import { useState } from 'react';
import TopnavCollapse from 'components/Topnav/components/TopnavCollapse';
import { useMaterialUIController } from 'context';
import TopnavRoot from 'components/Topnav/TopnavRoot';
import MDBox from 'components/MDBox';

export function Topnav({ routes, ...rest }) {
  const { formatMessage: msg } = useIntl();
  const location = useLocation();
  const { controller } = useMaterialUIController();
  const { darkMode, transparentSidenav, whiteSidenav } = controller;
  const [white] = useState(whiteSidenav);
  const [transparent] = useState(transparentSidenav);

  const renderRoutes = routes.map(
    ({ visibleInMenu = true, name, icon, noCollapse, key, href, path, onClick = () => {} }) => {
      const label = msg({ id: `page.${key}`, defaultMessage: name });

      let returnValue;
      if (visibleInMenu) {
        returnValue = href ? (
          <li key={`li-${key}`}>
            <Link
              href={href}
              key={key}
              target="_blank"
              onClick={onClick}
              rel="noreferrer"
              sx={{ textDecoration: 'none' }}
            >
              <TopnavCollapse
                name={label}
                icon={icon}
                active={location.pathname.includes(path)}
                noCollapse={noCollapse}
                ownerState={{
                  darkMode
                }}
              />
            </Link>
          </li>
        ) : (
          <li key={`li-${key}`}>
            <NavLink key={key} to={`/portal/${path}`} onClick={onClick}>
              <TopnavCollapse
                name={label}
                icon={icon}
                active={location.pathname.includes(path)}
                ownerState={{
                  transparentSidenav: transparent,
                  whiteSidenav: white,
                  darkMode
                }}
              />
            </NavLink>
          </li>
        );
      }
      return returnValue;
    }
  );

  return (
    <TopnavRoot
      {...rest}
      sx={{
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        py: 1,
        px: 2,
        borderRadius: 0
      }}
      ownerState={{
        transparentSidenav: transparent,
        whiteSidenav: white,
        darkMode
      }}
    >
      <MDBox
        component={NavLink}
        to="/home"
        display="flex"
        alignItems="center"
        sx={{
          position: 'absolute',
          left: '5px',
          justifyContent: 'center',
          flexDirection: 'column'
        }}
        aria-label={msg({ id: 'page.home' })}
      ></MDBox>
      <List
        sx={{
          display: 'flex',
          direction: 'row',
          margin: '0 auto'
        }}
      >
        {renderRoutes}
      </List>
    </TopnavRoot>
  );
}

Topnav.propTypes = {
  routes: PropTypes.arrayOf(PropTypes.object).isRequired
};
